var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notification-settings-cont" },
    [
      _c("section-title", {
        attrs: { title: "Subscription Groups", icon: "fas fa-users" },
      }),
      _c(
        "div",
        {
          staticClass: "notification-settings-section",
          style: { color: _vm.$vuetify.theme.dark ? "#FFFFFF" : "#000000" },
        },
        [
          !_vm.isLoadingData && _vm.getSubscriptionGroups.length > 0
            ? _vm._l(
                _vm.subscriptionGroupsList,
                function (subscriptionGroupItem, subscriptionGroupIndex) {
                  return _c("subscription-group", {
                    key: `subscription-group-key-${subscriptionGroupItem.id}`,
                    attrs: {
                      name: subscriptionGroupItem.name,
                      description: subscriptionGroupItem.description,
                      tenant: subscriptionGroupItem.tenant.name,
                      channels: subscriptionGroupItem.channels,
                    },
                    on: {
                      assign: function ($event) {
                        return _vm.assignChannelSubscriptionGroupHandler(
                          subscriptionGroupItem
                        )
                      },
                      edit: function ($event) {
                        return _vm.editSubscriptionGroupHandler(
                          subscriptionGroupItem
                        )
                      },
                      delete: function ($event) {
                        return _vm.deleteSubscriptionGroupHandler(
                          subscriptionGroupIndex
                        )
                      },
                    },
                  })
                }
              )
            : _vm._e(),
          !_vm.isLoadingData && _vm.getSubscriptionGroups.length === 0
            ? [
                _c("div", { staticClass: "no-results" }, [
                  _vm._v("No Subscription Groups detected!"),
                ]),
              ]
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "add-subscription-clickable",
              class: _vm.$vuetify.theme.dark ? "dark" : "light",
              on: { click: _vm.openGroupEditorHandler },
            },
            [_vm._v(" + add ")]
          ),
        ],
        2
      ),
      _c("section-title", {
        attrs: { title: "Subscribers (channels)", icon: "fas fa-user" },
      }),
      _c(
        "div",
        {
          staticClass: "notification-settings-section",
          style: { color: _vm.$vuetify.theme.dark ? "#FFFFFF" : "#000000" },
        },
        [_c("subscribers")],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          model: {
            value: _vm.showSubGroupEditor,
            callback: function ($$v) {
              _vm.showSubGroupEditor = $$v
            },
            expression: "showSubGroupEditor",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "accent" },
            [
              _c(
                "v-card-title",
                {
                  staticStyle: {
                    "background-color": "#47bd96",
                    color: "white",
                    "letter-spacing": "0.03rem",
                    height: "40px",
                  },
                  style: _vm.$vuetify.breakpoint.xsOnly
                    ? "text-align: center !important;"
                    : "",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.editMode ? "Edit Group" : "Add Group") +
                      " "
                  ),
                ]
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6", md: "8" } },
                            [
                              _c("v-text-field", {
                                ref: "subscriptionGroupName",
                                attrs: {
                                  label: "Name",
                                  filled: "",
                                  outlined: "",
                                  dense: "",
                                  required: "",
                                  rules: [_vm.rules.required],
                                },
                                model: {
                                  value: _vm.subscriptionGroupData.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.subscriptionGroupData,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "subscriptionGroupData.name",
                                },
                              }),
                              _c("v-textarea", {
                                attrs: {
                                  name: "subscriptionGroupDescription",
                                  label: "Description",
                                  filled: "",
                                  outlined: "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.subscriptionGroupData.description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.subscriptionGroupData,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "subscriptionGroupData.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6", md: "8" } },
                            [
                              _c(
                                "input-wrapper-2",
                                {
                                  attrs: {
                                    label: "Owner",
                                    info: "Select a Tenant for which you want the group to belong to.",
                                    "label-background-light": "#D2E2DE",
                                    "label-background-dark": "#162627",
                                    dense: "",
                                    "full-width": "",
                                  },
                                },
                                [
                                  _c("v-select", {
                                    ref: "selectOwnerInput",
                                    staticStyle: {
                                      width: "100%",
                                      margin: "4px 0",
                                    },
                                    attrs: {
                                      items: _vm.tenantOptions,
                                      "item-text": "label",
                                      "item-value": "value",
                                      placeholder: "Select Owner",
                                      dense: "",
                                      filled: "",
                                      solo: "",
                                      "hide-details": "",
                                      required: "",
                                      rules: [_vm.rules.required],
                                    },
                                    model: {
                                      value: _vm.subscriptionGroupData.owner,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.subscriptionGroupData,
                                          "owner",
                                          $$v
                                        )
                                      },
                                      expression: "subscriptionGroupData.owner",
                                    },
                                  }),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "", small: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.subscriptionGroupData.owner = null
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "#d50101",
                                          },
                                        },
                                        [_vm._v(" fas fa-times ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6", md: "8" } },
                            [
                              _c(
                                "input-wrapper",
                                {
                                  attrs: {
                                    label: "Active",
                                    "container-class": "pt-8",
                                    "label-background": _vm.$vuetify.theme.dark
                                      ? "rgb(30,30,30)"
                                      : "#FFFFFF",
                                    filled: "",
                                  },
                                },
                                [
                                  _c("v-switch", {
                                    ref: "groupActiveSwitchInput",
                                    staticStyle: { "margin-top": "0" },
                                    attrs: {
                                      label:
                                        _vm.subscriptionGroupData.active ===
                                        true
                                          ? "Yes"
                                          : "No",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.subscriptionGroupData.active,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.subscriptionGroupData,
                                          "active",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "subscriptionGroupData.active",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { plain: "" },
                      on: { click: _vm.closeGroupEditorHandler },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "span",
                    { on: { mouseenter: _vm.touchError } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled:
                              !_vm.subscriptionGroupData.name ||
                              (!!_vm.subscriptionGroupData.name &&
                                _vm.subscriptionGroupData.name.length < 1),
                            loading: _vm.saving,
                          },
                          on: { click: _vm.saveSubscriptionGroup },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(!!_vm.editMode ? "Save" : "Add") + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.showConfirmDelete,
            callback: function ($$v) {
              _vm.showConfirmDelete = $$v
            },
            expression: "showConfirmDelete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticStyle: {
                    "background-color": "#1c6e59",
                    color: "white",
                    "letter-spacing": "0.03rem",
                    height: "40px",
                  },
                  style: _vm.$vuetify.breakpoint.xsOnly
                    ? "text-align: center !important;"
                    : "",
                },
                [
                  _c("v-icon", { staticClass: "mr-2", attrs: { small: "" } }, [
                    _vm._v("fas fa-exclamation-triangle"),
                  ]),
                  _vm._v(
                    ' Delete "' + _vm._s(_vm.subscriptionGroupData.name) + '"? '
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { plain: "" },
                      on: { click: _vm.closeGroupEditorHandler },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red", loading: _vm.saving },
                      on: { click: _vm.deleteSubscriptionGroup },
                    },
                    [_vm._v(" Delete ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("channel-assign", {
        attrs: {
          show: _vm.showAssignChannelDialog,
          "group-data": _vm.selectedSubscriptionGroup,
        },
        on: {
          close: function ($event) {
            _vm.showAssignChannelDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }